import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '../../i18n'
import { getFontSize } from '../../utils/cssUtils'
import mq from '../../utils/mediaQuery'
import Button from '../../containers/Button'

const JoinUs = styled.section`
  position: relative;
  width: 100%;
  height: 320px;
  background-image: url('/static/images/corporate/corporate-apply-now.svg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  overflow: hidden;
  display: flex;
`
const JoinUsOverlay = styled.div`
  position: relative;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.8);
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0 120px 0 0;
  ${mq.tablet} {
    width: 506px;
    padding: 0 64px 0 80px;
  }
  ${mq.mobile} {
    width: 100%;
    padding: 0 16px;
  }
`
const JoinUsContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  width: calc(50% - 600px + 714px);
  ${mq.tablet} {
    width: 506px;
  }
  ${mq.mobile} {
    width: 100%;
  }
`
const JoinUsTitle = styled.h3`
  font-size: ${getFontSize('title')};
  color: #fff;
`
const JoinUsSummary = styled.p`
  margin-top: 8px;
  // ie11 fix
  width: 100%;
`

const ContactBtn = styled(props => <Button height={48} {...props} />)`
  margin-top: 24px;
`

const CorporateJoinUs = React.memo(({ onLinkClick }) => {
  const { t } = useTranslation('common')
  return (
    <JoinUs>
      <JoinUsOverlay>
        <JoinUsContent>
          <JoinUsTitle>{t('corporate.joinUsTitle')}</JoinUsTitle>
          <JoinUsSummary>{t('corporate.joinUsSummary')}</JoinUsSummary>
          <Link href='/corporate/contact'>
            <a onClick={onLinkClick}>
              <ContactBtn>{t('corporate.contactToKnowMore')}</ContactBtn>
            </a>
          </Link>
        </JoinUsContent>
      </JoinUsOverlay>
    </JoinUs>
  )
})

export default CorporateJoinUs
